import { ReactNode, useContext } from 'react';
import { ErrorView } from '../ErrorView';
import { DataAccessContext } from '@axo/shared/data-access/provider';

interface IError {
  children: ReactNode;
}

export function Error({ children }: IError) {
  const { state } = useContext(DataAccessContext);

  if (state.error !== undefined) {
    return <ErrorView title="Something went wrong" description={state.error} />;
  }

  return <>{children}</>;
}
